interface RouteKeysInterface {
  root: string,
  home: string
}

export const ROUTE_KEYS: RouteKeysInterface = {
  root: 'root',
  home: 'home',
};
